import { EMPTY_VALUE } from '@/constants/app.constants';
import { ExpandableComment } from './ExpandableComment';

interface BoxedTextProps {
  children: string | null;
  isExpandable?: boolean | undefined;
}

export function BoxedText({ children, isExpandable = false }: BoxedTextProps) {
  const content =
    children && isExpandable ? (
      <ExpandableComment comment={children} shouldKeepLineBreaks />
    ) : (
      children || EMPTY_VALUE
    );

  return (
    <p className="rounded-lg border bg-background p-3 text-sm whitespace-pre-line">{content}</p>
  );
}
